import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="I work with businesses, General Counsel, and other attorneys to provide next level trademark services." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
